// extracted by mini-css-extract-plugin
export var active = "_sc-1";
export var circle = "_sc-0";
export var completed = "_sc-2";
export var connector = "_sc-4";
export var connectorCompleted = "_sc-7";
export var connectorSpacer = "_sc-5";
export var iconStrokeOverride = "_sc-8";
export var labelContainer = "_sc-6";
export var pending = "_sc-3";